import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { 
  fetchOnboardings, 
  heartbeat,
  clearChangedOnboardingIds,
  selectOnboardingLoading,
  selectOnboardingError,
  selectAllOnboardings,
  selectFilterDsoOnboardings,
  selectSortDsoOnboardings,
  toggleFilterDsoOnboardings,
  toggleSortDsoOnboardings
} from './store/onboardingSlice';
import OnboardingViewRow from './OnboardingViewRow';
import './OnboardingView.css';

function OnboardingView() {
  const dispatch = useAppDispatch();
  // const onboardingIds = useAppSelector(selectAllOnboardingIds);
  const onboardings = useAppSelector(selectAllOnboardings);
  const loading = useAppSelector(selectOnboardingLoading);
  const error = useAppSelector(selectOnboardingError);

  const settingFilterDsoOnboardings = useAppSelector(selectFilterDsoOnboardings);
  const settingSortDsoOnboardings = useAppSelector(selectSortDsoOnboardings);

  const sortBy = 'createdAt';


  

  // Initial fetch
  useEffect(() => {
    dispatch(fetchOnboardings());
  }, [dispatch]);

  // Heartbeat effect
  useEffect(() => {
    // Set up heartbeat to run every 15 seconds
    const heartbeatInterval = setInterval(() => {
      dispatch(heartbeat());
    }, 10000); // 15 seconds = 15000 milliseconds
    
    // Cleanup interval on component unmount
    return () => {
      clearInterval(heartbeatInterval);
    };
  }, [dispatch]);

  // Clear changed IDs after a delay to remove visual indicators
  useEffect(() => {
    const clearTimer = setTimeout(() => {
      dispatch(clearChangedOnboardingIds());
    }, 3000); // Clear visual indicators after 3 seconds

    return () => clearTimeout(clearTimer);
  }, [dispatch]);


 


  if (loading || onboardings.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '256px' }}>
        <div style={{ fontSize: '18px' }}>Loading onboardings...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '256px' }}>
        <div style={{ color: '#ef4444' }}>Error: {error}</div>
      </div>
    );
  }

  console.log("onboardings ", onboardings);

  const activeOnboardings = onboardings.filter((onboarding) => {
    return onboarding.bIsOnboarding;
    // return true;
  });

  console.log("activeOnboardings ", activeOnboardings);

  const filteredOnboardings = activeOnboardings.filter((onboarding) => {
    if (settingFilterDsoOnboardings) {
      return onboarding.isDso;
    }
    return true;
  })

  console.log("filteredOnboardings ", filteredOnboardings);
  
  const getGroupSortedOnboardings = (onboardings) => {

    const groups_map = onboardings.reduce((acc, onboarding) => {
      if (acc[onboarding.organizationId]) {
        acc[onboarding.organizationId].push(onboarding);
      } else {
        acc[onboarding.organizationId] = [onboarding];
      }
      return acc;

    }, {});

    console.log("groups_map ", groups_map);

    const sortedInGroups = Object.values(groups_map).map(group => {
      return group.sort((a, b) => {
        return a[sortBy] - b[sortBy];
      });
    })

    console.log("sortedInGroups ", sortedInGroups);

    const sortedGroups = sortedInGroups.sort((a, b) => {
      return a[0][sortBy] - b[0][sortBy];
    });
    console.log("sortedGroups ", sortedGroups);
    return sortedGroups.flat();

  }

  const sortedOnboardings = getGroupSortedOnboardings(filteredOnboardings);
  // const sortedOnboardings = activeOnboardings;
  console.log("groupSortedOnboardings ", sortedOnboardings);


  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Current Onboardings ({sortedOnboardings.length})</h1>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button 
            onClick={() => dispatch(toggleFilterDsoOnboardings())}
            style={{
              padding: '8px 16px',
              backgroundColor: settingFilterDsoOnboardings ? '#007bff' : '#f8f9fa',
              color: settingFilterDsoOnboardings ? 'white' : '#333',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Filter DSO Only
          </button>
          <button 
            onClick={() => dispatch(toggleSortDsoOnboardings())}
            style={{
              padding: '8px 16px',
              backgroundColor: settingSortDsoOnboardings ? '#007bff' : '#f8f9fa',
              color: settingSortDsoOnboardings ? 'white' : '#333',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Group by Organization
          </button>
        </div>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="onboarding-table">
          <thead>
            <tr>
              <th className="table-header">Location</th>
              <th className="table-header">Signed Date</th>
              <th className="table-header">Kickoff</th>
              <th className="table-header">Linked to Practice</th>
              <th className="table-header">Registration Complete</th>
              <th className="table-header">Port Request</th>
              <th className="table-header">Phones</th>
              <th className="table-header">Training KB</th>
              <th className="table-header">Training Workflow</th>
              <th className="table-header">Go Live</th>
            </tr>
          </thead>
          <tbody>
            {sortedOnboardings.map((onboarding) => (
              <OnboardingViewRow 
                key={onboarding.id}
                onboardingId={onboarding.id}
              />
            ))}
          </tbody>
        </table>
      </div>  
    </div>
  );
}

export { OnboardingView };